import { PopupSize, PopupTemplate, ButtonColorTheme } from "..";
import { useHandleEsc } from "../../lib";
import { TaskType } from "../../shared/db";
import { useSelectTheme } from "../../store";

const deviceTypeData = {
  stopwatch_movesense_stream: {
    name: "Movesense Task Missing",
    description: `You selected Movesense for this project. Because Movesense streaming requires participants to manually initiate data collection, you must add a corresponding Movesense task to capture data.`,
    cancelText: "Remove Movesense",
    buttonText: "Add Scheduled Task",
    optionalSecondaryButtonContent: "Add Event Tracker",
  },
  stopwatch_garmin_stream: {
    name: "ACC Streaming Task Missing",
    description: `You've selected to use Garmin device for Accelerometer streaming, but did not add the relevant task. Please go to the "Participant Tasks" section of the page and add an "ACC Streaming" task.`,
    cancelText: "I am no longer using ACC Streaming",
    buttonText: "Add Acc Streaming Task",
    optionalSecondaryButtonContent: undefined,
  },
};

export const PopupMissingDeviceTask = (props: {
  deviceTaskType: TaskType.StopwatchMovesenseStream | TaskType.StopwatchGarminStream;
  closeAction: () => void;
  exitAction: () => void;
  onAddScheduledTask?: () => void;
  onAddEventTracker?: () => void;
  onAddAccStreamingTask?: () => void;
}) => {
  const { color, fontWeight } = useSelectTheme();
  const {
    closeAction,
    exitAction,
    deviceTaskType,
    onAddScheduledTask,
    onAddEventTracker,
    onAddAccStreamingTask,
  } = props;
  const { name, description, cancelText, buttonText, optionalSecondaryButtonContent } =
    deviceTypeData[deviceTaskType];
  const isMovesense = deviceTaskType === TaskType.StopwatchMovesenseStream;

  const handleMainButton = () => {
    exitAction();
    if (isMovesense) {
      onAddScheduledTask?.();
      return;
    }
    onAddAccStreamingTask?.();
  };

  const handleAddEventTracker = () => {
    exitAction();
    onAddEventTracker?.();
  };

  useHandleEsc(closeAction);

  const cancelLink = (
    <button
      type="button"
      onClick={closeAction}
      css={{
        color: color.warning,
        fontWeight: fontWeight.bold,
        cursor: "pointer",
        border: "none",
        background: "transparent",
        padding: 0,
      }}
    >
      {cancelText}
    </button>
  );

  return (
    <PopupTemplate
      {...{
        title: name,
        description,
        background: true,
        popupSize: PopupSize.Medium,
        handleClosePopup: exitAction,
        hideCancelButton: true,
        optionalBottomLeftContent: cancelLink,
        mainFunction: handleMainButton,
        buttonContent: buttonText,
        buttonColorTheme: ButtonColorTheme.Primary,
        optionalSecondaryButtonContent: isMovesense ? optionalSecondaryButtonContent : undefined,
        optionalSecondaryButtonFunction: isMovesense ? handleAddEventTracker : undefined,
        optionalSecondaryButtonColorTheme: ButtonColorTheme.Primary,
        optionalSecondaryButtonDisabled: false,
      }}
    />
  );
};
